module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "trigger"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.effect
    }
  }, [(_vm.show) ? _c('div', {
    ref: "popover",
    class: ['tooltip', _vm.placement]
  }, [_c('div', {
    staticClass: "tooltip-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-inner"
  }, [_vm._t("content", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)]) : _vm._e()])], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2aaf7239", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2aaf7239!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tooltip.vue
// module id = 186
// module chunks = 0